// extracted by mini-css-extract-plugin
export default {"table_container":"Table_table_container__NWRhU","table_box":"Table_table_box__VxaIY","table_box_yoon":"Table_table_box_yoon__xMuha"};